import { type FC } from 'react';
import { MiniGrid } from '@direct-frontend/components';
import { AddonRowStub } from './components/AddonRow';
import { Wrapper } from './components/Wrapper';
type ProductAddonsIslandStubProps = { countRows?: number };

export const ProductAddonsIslandStub: FC<ProductAddonsIslandStubProps> = ({ countRows = 3 }) => (
    <Wrapper>
        <MiniGrid>
            {Array.from({ length: countRows }).map((_, index) => (
                <AddonRowStub key={index} />
            ))}
        </MiniGrid>
    </Wrapper>
);
